module.exports = __webpack_public_path__ + "assets/htu-2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HTU-modal/htu-2.jpg
// module id = 1189
// module chunks = 7